import MediaWithPreview from './MediaWithPreview';

export default MediaWithPreview;
